(function (window, document) {
  'use strict';

  var submissionKey = 'htoNitroSubmission';
  var NITRO_ORG_ID = '32c02d8f-9cb3-4335-be63-ad7f6386a199';

  window._nitroReady = false;
  window._nitroIdentifiers = null;
  var pendingQueue = [];

  /**
   * Safely identify visitor in Nitro.
   * Ensures Nitro has initialized roamingId and nitroId before dispatching.
   */
  function nitroIdentify(email, phone, name) {
    try {
      var safeEmail = email && typeof email === 'string' ? email.trim() : null;
      var safePhone = phone && typeof phone === 'string' ? phone.trim() : null;
      var safeName = name && typeof name === 'string' ? name.trim() : null;

      if (!safeEmail && !safePhone && !safeName) return;

      if (!window._nitroReady) {
        pendingQueue.push({ type: 'identify', email: safeEmail, phone: safePhone, name: safeName });
        return;
      }

      if (typeof window.nitro === 'function') {
        if (typeof window.nitro.identify === 'function') {
          window.nitro.identify(safeEmail, safePhone, safeName);
        } else {
          window.nitro('identify', safeEmail, safePhone, safeName);
        }
        console.log('[Nitro Pixel] Identify sent:', { email: safeEmail, phone: safePhone, name: safeName });
      }
    } catch (err) {
      console.error('Nitro identify failed:', err);
    }
  }

  /**
   * Safely track custom events in Nitro.
   * Ensures Nitro has initialized roamingId and nitroId before dispatching.
   */
  function nitroTrack(eventName, eventValue) {
    try {
      if (!eventName) return;
      var safePayload = (typeof eventValue === 'object' && eventValue !== null)
        ? Object.assign({ page: window.location.href }, eventValue)
        : { value: eventValue, page: window.location.href };

      if (!window._nitroReady) {
        pendingQueue.push({ type: 'track', eventName: eventName, payload: safePayload });
        return;
      }

      if (typeof window.nitro === 'function') {
        if (typeof window.nitro.track === 'function') {
          window.nitro.track(eventName, safePayload);
        } else {
          window.nitro('track', eventName, safePayload);
        }
        console.log('[Nitro Pixel] Event tracked:', eventName, safePayload);
      }
    } catch (err) {
      console.error('Nitro track failed:', err);
    }
  }

  /**
   * Flush pending events once Nitro SDK is ready with valid roamingId.
   */
  function flushPendingQueue() {
    while (pendingQueue.length > 0) {
      var action = pendingQueue.shift();
      if (action.type === 'identify') {
        nitroIdentify(action.email, action.phone, action.name);
      } else if (action.type === 'track') {
        nitroTrack(action.eventName, action.payload);
      }
    }
  }

  /**
   * Unified identify and track helper for forms.
   */
  function nitroIdentifyAndTrack(identity, eventPayload) {
    identity = identity || {};
    nitroIdentify(identity.email, identity.phone, identity.name);
    nitroTrack('hto_form_submission', eventPayload || {
      form: 'home_try_on',
      status: 'submitted',
      page: window.location.href
    });

    return {
      success: true,
      ready: window._nitroReady,
      status: window._nitroReady ? 'event_sent' : 'queued_waiting_for_nitro_ready'
    };
  }

  // Expose global helpers
  window.nitroIdentify = nitroIdentify;
  window.nitroTrack = nitroTrack;
  window.nitroIdentifyAndTrack = nitroIdentifyAndTrack;

  /**
   * Process pending HTO submission on the redirected success message page.
   * Called strictly after Nitro is ready so roamingId is present.
   */
  var hasProcessedRedirect = false;
  function processPendingSubmission(source) {
    if (hasProcessedRedirect) return;

    var rawSubmission;
    try {
      rawSubmission = window.sessionStorage.getItem(submissionKey);
    } catch (e) {
      return;
    }
    if (!rawSubmission) return;

    try {
      var submission = JSON.parse(rawSubmission);
      if (submission && typeof submission === 'object') {
        hasProcessedRedirect = true;

        // Keep visitor identified on the redirect page
        nitroIdentify(submission.email, submission.phone, submission.name);

        // Only fire custom event if it was not already fired upon form submit
        if (!submission.firedOnSubmit) {
          nitroTrack('hto_form_submission', {
            form: 'home_try_on',
            status: 'submitted',
            pincode: submission.pincode || '',
            city: submission.city || '',
            state: submission.state || '',
            appointment_date: submission.appointment_date || '',
            appointment_time: submission.appointment_time || '',
            page: window.location.href,
            source: source || 'redirect_success_page'
          });
        } else {
          console.log('[Nitro Pixel] Submission event already sent on form submit. Skipping duplicate tracking on redirect.');
        }

        try {
          window.sessionStorage.removeItem(submissionKey);
        } catch (e) {
          /* storage remove blocked — not critical */
        }
      }
    } catch (err) {
      console.error('Nitro HTO redirect tracking failed:', err);
    }
  }

  // Setup nitroSettings.ready hook - Nitro SDK calls this ONLY after roamingId is resolved!
  var previousReady = window.nitroSettings && window.nitroSettings.ready;
  window.nitroSettings = window.nitroSettings || {};
  window.nitroSettings.ready = function (orgId, roamingId, nitroId) {
    window._nitroReady = true;
    window._nitroIdentifiers = { orgId: orgId, roamingId: roamingId, nitroId: nitroId };
    console.log('[Nitro Pixel] SDK ready with roamingId:', roamingId);

    if (typeof previousReady === 'function') {
      try {
        previousReady(orgId, roamingId, nitroId);
      } catch (error) {
        console.error('Nitro previous ready callback failed:', error);
      }
    }

    // Flush any queued calls and process redirect submission with valid roamingId
    flushPendingQueue();
    processPendingSubmission('nitro_ready');
  };

  // Step 1: Install the Nitro Script snippet
  (function (n, i, t, r, o) {
    var a;
    var m;
    n.NitroObject = o;
    n[o] = n[o] || function () {
      (n[o].q = n[o].q || []).push(arguments);
    };
    n[o].l = 1 * new Date();
    n[o].h = r;
    a = i.createElement(t);
    m = i.getElementsByTagName(t)[0];
    a.async = 1;
    a.src = r;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://x.nitrocommerce.ai/nitro.js', 'nitro');

  // Step 1: Configure Nitro with Store Org ID
  window.nitro('configure', NITRO_ORG_ID);

})(window, document);


